// Is the object literal empty?
// https://stackoverflow.com/questions/2340509/javascript-trivia-check-for-equality-against-the-empty-object
export function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

export function isUndefined(obj) {
    return typeof obj === "undefined";
}

export function isNull(obj) {
    return obj === null;
}

export function isPresent(obj) {
    return !isUndefined(obj) && !isNull(obj) && !isEmpty(obj);
}


// Access a nested object value by following a path of key values. For example:
// const obj = { a: { z: 'foo' }, b: 'bar'};
// `resolvePath(obj, 'a.z')`
// https://stackoverflow.com/a/43849204/19588
export const resolvePath = (object, path) => {
    const reducer = (o, pathSegment) => o ? o[pathSegment] : undefined;
    return path.split('.').reduce(reducer, object)
}


// Remove properties of an object that have a null, undefined or empty string value.
// @returns {Object} New object with entries that have a null, undefined or empty string value removed.
export function removeEmpty(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => typeof v !== "undefined" && v !== null && v !== ""));
}


// Is the item an object.
// @returns {boolean}
// @link https://stackoverflow.com/a/37164538/19588
export function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

// Merge two simple objects together in an immutable fashion (does not modify the inputs).
// @link https://stackoverflow.com/a/37164538/19588
export default function mergeDeep(target, source) {
    let output = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = mergeDeep(target[key], source[key]);
            } else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
}